
<div class="filters-container" [formGroup]="modulesForm" fxLayout="column">
    <span fxFlex="1 1 100%" class="mb-4 p-24 pt-12 pb-4"><strong>{{'GRID.FILTERS.ADVANCED' | translate}}</strong></span>
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="0 1 100%" color="accent" class="m-12 p-12 mt-0">
        <mat-label fxFlex="100">{{'DYNAMIC_FILTERS.MODULE_SELECTOR' | translate}}</mat-label>
        <mat-select formControlName="moduleSelect">          
            <mat-option *ngFor="let item of modules" [value]="item?.id">
                <ng-container [ngSwitch]="item?.description">
                    <span *ngSwitchCase="modulesDescription?.Alerts">{{'NAV.ALERTS' | translate}}</span>
                    <span *ngSwitchCase="modulesDescription?.Cases">{{'NAV.CASES' | translate}}</span>
                    <span *ngSwitchCase="modulesDescription?.Complaint">{{'NAV.COMPLAINTS' | translate}}</span>
                    <span *ngSwitchDefault>{{'DYNAMIC_FILTERS.NO_MODULE_AVALAIBLE' | translate}}</span>
                </ng-container>
            </mat-option>
        </mat-select>
    </mat-form-field>
    
    <mat-divider></mat-divider>

    <form [formGroup]="searchFormCases" fxLayout="row wrap" class="p-24 pb-56"
        *ngIf="modulesForm.get('moduleDescription')?.value == modulesDescription?.Cases">
        <div fxLayout="column" fxFlex="100%" class="mb-12">
            <mat-label> {{ 'CASES.CASE_TITLE' | translate }}</mat-label>
            <mat-form-field fxFlex="100%" appearance="outline">
                <input matInput formControlName="title" autocomplete="off"
                    [maxlength]="textFiltersMaxLength">
            </mat-form-field>
        </div>
        <!-- STATUS_DESCRIPTION DROPDOWN -->
        <mat-label fxFlex="100">{{'ALERTS.FIELDS.STATUS_DESCRIPTION' | translate}}
        </mat-label>
        <mat-form-field appearance="outline" floatLabel="always" class="mb-12" fxFlex="100%" color="accent">
            <mat-select formControlName="status" placeholder="{{'PLACEHOLDER.ALL' | translate}}">
                <mat-option [value]="null">{{'PLACEHOLDER.ALL' | translate}}
                </mat-option>
                <mat-option *ngFor="let item of statusData" [value]="item.id.toString()">
                    {{ "CASES.STATUS." + item.description | translate}}
                </mat-option>
            </mat-select>
        </mat-form-field>        
        <!-- RESOLUTION_DESCRIPTION DROPDOWN -->
        <mat-label fxFlex="100">{{'CASES.CASE_TYPE' | translate}}
        </mat-label>
        <mat-form-field appearance="outline" floatLabel="always" class="mb-12" fxFlex="100%" color="accent">
            <mat-select formControlName="caseType" placeholder="{{'PLACEHOLDER.ALL' | translate}}">
                <mat-option [value]="null">{{'PLACEHOLDER.ALL' | translate}}
                </mat-option>
                <mat-option *ngFor="let item of caseTypes" [value]="item.id.toString()">
                    {{ "CASES.TYPES." + item.description | translate}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <app-date-range-filter [form]="searchFormCases" fromControlName="createdDateFrom" toControlName="createdDateTo"
        fromKeyLabel="COMMON_LIST.FILTERS.CREATED_DATE_FROM"
        toKeyLabel="COMMON_LIST.FILTERS.CREATED_DATE_TO"></app-date-range-filter>
                                
        <app-date-range-filter [form]="searchFormCases" fromControlName="modifiedDateFrom"
        toControlName="modifiedDateTo" fromKeyLabel="ALERTS.FILTERS.MODIFIED_FROM"
        toKeyLabel="ALERTS.FILTERS.MODIFIED_TO"></app-date-range-filter>

    </form>

    <form [formGroup]="searchFormAlert" fxLayout="row wrap" class="p-24 pb-56"
     *ngIf="modulesForm.get('moduleDescription')?.value == modulesDescription?.Alerts">

        <mat-label fxFlex="100">{{'ALERTS.SOURCEID' | translate}}
        </mat-label>
        <mat-form-field appearance="outline" floatLabel="always" class="mb-12" fxFlex="100%" color="accent">
            <mat-select formControlName="sourceId" placeholder="{{'PLACEHOLDER.ALL' | translate}}">
                <mat-option [value]="null">{{'PLACEHOLDER.ALL' | translate}}
                </mat-option>
                <mat-option *ngFor="let item of sourcesData" [value]="item.id">
                    {{ item.description }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <app-date-range-filter [form]="searchFormAlert" fromControlName="createdDateFrom" toControlName="createdDateTo"
            fromKeyLabel="COMMON_LIST.FILTERS.CREATED_DATE_FROM"
            toKeyLabel="COMMON_LIST.FILTERS.CREATED_DATE_TO"></app-date-range-filter>

        <mat-label fxFlex="100">{{'ALERTS.CRITICALITY' | translate}}
        </mat-label>
        <mat-form-field appearance="outline" floatLabel="always" class="mb-12" fxFlex="100%" color="accent">
            <mat-select formControlName="criticalityId" placeholder="{{'PLACEHOLDER.ALL' | translate}}">
                <mat-option [value]="null">{{'PLACEHOLDER.ALL' | translate}}
                </mat-option>
                <mat-option *ngFor="let item of criticalitiesData" [value]="item.id">
                    {{"ALERTS.CRITICALITY." + item.description | translate}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>

    <!--APPLY FILTERS BUTTON-->
    <mat-card fxLayout="row" class="aply-filters-button">
        <button fxFlex="50" color="accent" mat-raised-button (click)="aplyFilters()"
            [disabled]="searchFormCases.invalid || progressBar" class="mx-8"
            matTooltip=" {{'COMMON_LIST.ACTIONS.APPLY' | translate}}" matTooltipPosition="above">
            {{'COMMON_LIST.ACTIONS.APPLY' | translate}}
        </button>
        <button fxFlex="40" color="primary" mat-raised-button (click)="clearFilters()" class="mx-8"
            matTooltip=" {{'COMMON_LIST.ACTIONS.CLEAR' | translate}}" matTooltipPosition="above" [disabled]="progressBar">
            {{'COMMON_LIST.ACTIONS.CLEAR' | translate}}
        </button>
    </mat-card>
</div>